<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-4">
            <a v-if="getRoleId != '33'" @click="openPage('/schedule/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Studio
              </div>
              <div class="col-sm-8">
                <b-form-select name="day" v-validate="'required'" @change="changeStudio" v-model="changeStudioId">
                  <option :value="null">Please select</option>
                  <option v-for="item in optStudio" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <div class="col-12">
          <div class="overflow-auto">
            <div class="text-uppercase font-600 mb-10">
              <span v-for="nameStudio in optStudio" :key="nameStudio.id">
                <span v-if="nameStudio.id === changeStudioId">
                  {{nameStudio.name}}
                </span>
              </span>
            </div>
            <table class="table table-bordered section-table text-center mb-0">
              <thead>
                <tr>
                    <th>Time</th>
                    <th>Monday</th>
                    <th>Tuesday</th>
                    <th>Wednesday</th>
                    <th>Thursday</th>
                    <th>Friday</th>
                    <th>Saturday</th>
                    <th>Sunday</th>
                </tr>
              </thead>
              <tbody>
                  <tr class="time-schedule" v-for="row1 in items" :key="row1.id">
                      <td class="time">{{parseTime(row1.time_start)}} - {{parseTime(row1.time_end)}}</td>
                      <template v-for="(day, index) in 7">
                        <td :key="index+'1'" class="off" v-if="checkClassNotExist(row1, index, day)"></td>
                        <template v-for="(row2, index) in row1.schedule">
                          <td :key="index+'2'" v-if="row2.classes_days_id === day" class="on" :class="row2.status === 'inactive' ? 'inactive' : ''">
                            <div class="font-600 font-13">{{ row2.class.name }}</div>
                            <div>{{ row2.coach.name }}</div>
                            <hr class="mb-5 mt-5 white">
                            <div>
                              <b-button v-if="getRoleId != '33'" size="sm" @click="editItem('/schedule/edit?id=' + row2.id)" class="btn-table2 mr-1">
                                <i class="far fa-edit"></i>
                              </b-button>
                              <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteItem(row2.id, row2.studio_id)" class="btn-table2">
                                <i class="far fa-trash-alt"></i>
                              </b-button>
                            </div>
                          </td>
                        </template>
                      </template>
                  </tr>
              </tbody>
            </table>
          </div>
          <div class="bg-primary p-15 font-13 mb-30 hidden">
              <div class="row">
                  <div class="col-sm-6">
                      <div class="row">
                          <div class="col-lg-6">
                              <div class="font-bold text-right minimize">Summary:</div>
                          </div>
                          <div class="col-lg-6">
                              <table class="summary-table font-500">
                                  <tbody>
                                      <tr>
                                          <td class="text-label">Location:</td>
                                          <td>Studio 1</td>
                                      </tr>
                                      <tr>
                                          <td class="text-label">Class:</td>
                                          <td>TRX</td>
                                      </tr>
                                      <tr>
                                          <td class="text-label">Coach:</td>
                                          <td>Eric</td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
                  <div class="col-sm-6">
                      <div class="row align-items-center">
                          <div class="col-lg-4">
                              <table class="summary-table font-500">
                                  <tbody>
                                      <tr>
                                          <td class="text-label">Seat:</td>
                                          <td>-</td>
                                      </tr>
                                      <tr>
                                          <td class="text-label">Time:</td>
                                          <td>-</td>
                                      </tr>
                                      <tr>
                                          <td class="text-label">Day:</td>
                                          <td>-</td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                          <div class="col-lg-8">
                              <a class="btn-border-black hidden" href="#">Book Class</a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
// import moment from 'moment'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'classes',
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      dataBranch: [],
      branch_id: null,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      changeStudioId: 1,
      getRoleId: Auth.Session.get().paradigm_role,
      filter: null,
      optStudio: null,
      notificationSystem: {
        options: {
          success: {
            position: 'bottomRight'
          }
        }
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    checkClassNotExist (item, index, day) {
      // console.log(day, index)
      let hasClassInArray = item.schedule[index]

      let hasClassInDay = item.schedule.find(classDay => classDay.classes_days_id === day)

      if (!hasClassInArray && !hasClassInDay) return true
      else if (!hasClassInArray && hasClassInDay) return false

      if (hasClassInArray.classes_days_id !== day && !hasClassInDay) {
        // console.log('day', hasClassInArray.classes_days_id)
        // console.log(hasClassInDay)
        return true
      } else return false
    },
    parseTime (value) {
      return (value).slice(0, -3)
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editItem (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteItem(event, studio) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/classes_schedule/'.concat(event)).then(response => {
            // this.$router.go()
            this.changeStudio(studio)
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    parseImg (value) {
      return Auth.apiUrl + 'compro/v1/img/classes_schedule/' + value
    },
    changeStudio (event) {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/classes_schedule/'+event+'/all?sorting=time_start&sorting_type=asc').then(response => {
        this.items = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeBranch(event) {
      this.changeStudioId = null
      axios.get('fitness/v1/studio?sorting=id&sorting_type=asc&branch_id=' + event).then(response => {
        this.optStudio = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/classes_schedule/1/all?sorting=time_start&sorting_type=asc').then(response => {
        this.items = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/studio?sorting=id&sorting_type=asc').then(response => {
        this.optStudio = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
